import { useEffect } from 'react';

export function useRefetchForStaleData(refetch: Function) {
  // workaround for StaleWhileRevalidate cache strategy of service worker
  useEffect(() => {
    setTimeout(refetch, 3000);
  }, [refetch]);
}
